import React, { Component } from 'react';
import RepositoryConfigAddEdit from './repository_addedit';
import RepositoryConfigEdit from './repository_edit';
import { withDomains, RESTExecutor } from '../../../lib/domain';
import { Table, Row, Button, Drawer, Divider, Input, message } from 'antd';
import Title from 'antd/lib/typography/Title';
import { Link } from 'react-router-dom';
import { showErrorInNotification, NetworkDelaySearch, overrideHeaderTitle, overrideHeaderBack, formatMoney } from '../../../lib/util';
import ErrorWrapper from '../../../lib/error_wrapper';
import { BasicHeader } from '../../../components/basic_header';
import { setting_quick_menu } from '../../../util/ui_util';
import { TransparentButton } from '../../../components/basic_items';

import {PauseCircleFilled,PlayCircleFilled} from '@material-ui/icons';
const queryString = require('query-string');

const fetcher_config_list = ({ props, onEditPressed, onDeletePressed,onStatusChange }) => [
    {
        title: "Repository Name",
        dataIndex: 'name',
        key: 'name',
        className:'bold-cell'
    },
    {
        title: "Repository Description",
        dataIndex: 'description',
        key: 'description',
    },
    {
        title: "Fetcher",
        dataIndex: 'fetcher',
        key: 'fetcher',
        render:(value,record)=>{
            return value||record.fetcher_id
        }
    },
    {
        title: "",
        dataIndex: 'id',
        key: 'actions',
        render: (id, data) => {
            return <div style={{
                display:'flex',
                flexDirection:'row',
                alignItems:'center'
            }}>
                <Button type='link' onClick={() => {
                    typeof onEditPressed === 'function' && onEditPressed(data);
                }}>Edit</Button>
                <Divider type='vertical' />
                <Link to={`/settings/data-repository/${id}/selectors`}>
                    <Button type='link'>Selectors</Button>
                </Link>
                <Divider type='vertical' />
                <Button type='link' onClick={() => {

                    typeof onStatusChange === 'function' && onStatusChange(data.id, {
                        stop: data.stop ? false : true
                    });
                }}>{data.stop ?<PlayCircleFilled className='success-icon' titleAccess='Tap to resume'/> : <PauseCircleFilled className='danger-icon' titleAccess='Tap to pause'/> }</Button>
                {/* <Button type='link' style={{color:'red'}} onClick={()=>{
                    typeof onDeletePressed==='function' && onDeletePressed(id);
                }}>Delete</Button> */}
            </div>
        }
    }
]

class RepositoryList extends Component {
    constructor(props) {
        super(props)

        this.state = {
            add_edit_status: null,
            edit_config_id: null,
            filter_query: {},
            selected_ids: [],
            all_selected: false
        };
        this.has_changed = false;

        this.list_fetcher_configs = RESTExecutor.list().config({
            label: 'list',
            params: {
                per_page: 100,
                page: 1
            }
        }).connect(props.domains.datarepository);

        this.export_data = RESTExecutor.post().config({
            label: 'export'
        }).callbacks((success) => {
            this.setState({ selected_ids: [], all_selected: false })
            // console.log("download url",success)
            window.open(success.result.url, '_blank');

        }, (error) => {
            showErrorInNotification(error)
        }).connect(props.domains.settings);


        this.patch_fetcher_config = RESTExecutor.patch().config({
            label: 'detail',
            // params: {
            //   source_id: this.props.source_id,
            //   config_id: this.props.edit_id
            // }
          }).callbacks((success) => {
            message.success(success.result.message||"Operation Successfull",1);
            this.list_fetcher_configs.execute();
      
          }, (error) => {
            showErrorInNotification(error)
              }).connect(props.domains.datarepository);

        // this.list_fetcher_configs.execute();

        this.delay_search = new NetworkDelaySearch();


    };
    stateUpdater = ({
        stateKey,
        valueKey,
        value,
        appendObj = {},
        callback
    }) => {
        let newData = this.state[stateKey];
        this.has_changed = true;
        if (valueKey) {
            newData[valueKey] = value;
        }
        if (appendObj) {
            Object.assign(newData, appendObj)
        }
        console.log(newData);
        this.setState({
            [stateKey]: newData
        }, () => {
            typeof callback === 'function' && callback()
        })
    }



    render() {

        // if (!this.props.source_id) {
        //     return <Spin />
        // }
        let list_fetcher_configs_resp = this.list_fetcher_configs.response();
        let patch_fetcher_config_resp=this.patch_fetcher_config.response();
        let list_fetcher_configs_data = list_fetcher_configs_resp.result || {};
        let rowsData = list_fetcher_configs_data.rows || [];
        let rowsMeta = list_fetcher_configs_resp.meta || {};
        const { filter_query, selected_ids } = this.state;
        let export_data_resp = this.export_data.response();

        return (
            <div>
                <BasicHeader no_back title="Data Repository"
                    menu_items={setting_quick_menu}
                    right={[
                        <TransparentButton
                            label="Add New"
                            className='cta-primary'
                            hint="Add New Data Repository"
                            onClick={() => {
                                this.setState({
                                    add_edit_status: 'add'
                                })
                            }}

                        />,
                        <TransparentButton
                            label="Export"
                            hint="Export Selected Data Repository"
                            disabled={selected_ids.length == 0}
                            onClick={() => {
                                this.export_data.execute({
                                    repositories: this.state.all_selected ? true : selected_ids
                                });
                            }}

                        />
                    ]}

                />

                <div className='filter-card'>
                    <div className='filter-card-top' style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        flexWrap: 'nowrap',

                    }}>
                        <Input.Search
                            autoFocus
                            placeholder="Search For"
                            style={{
                            }}
                            value={filter_query.query}
                            onChange={(e) => {
                                this.stateUpdater({
                                    stateKey: 'filter_query', valueKey: 'query', value: e.target.value, callback: () => {

                                        this.delay_search.onSearch(() => {
                                            this.props.history.push({
                                                search: queryString.stringify({ ...this.state.filter_query, per_page: 100, page: 1 })
                                            })
                                        })

                                    }
                                })
                            }} />
                    </div>
                </div>
                <ErrorWrapper
                    error={list_fetcher_configs_resp}
                    onReload={() => {
                        this.list_fetcher_configs.execute()
                    }}
                >
                    <div className='default-card' style={{ padding: 0 }}>
                        <Table
                            className='main-table '
                            loading={list_fetcher_configs_resp.fetching || export_data_resp.fetching||patch_fetcher_config_resp.fetching}
                            size='small'
                            scroll={{ x: true }}
                            rowSelection={{
                                onChange: (selected_ids) => {
                                    if (selected_ids.length != rowsMeta.data_count) {
                                        this.setState({ all_selected: false })
                                    }
                                    this.setState({ selected_ids })
                                },
                                selectedRowKeys: selected_ids
                            }}
                            pagination={{
                                simple: false,
                                position: 'bottom',
                                onChange: (current, size) => {
                                    this.props.history.push({
                                        // pathname:"users",
                                        search: queryString.stringify({ ...this.state.filter_query, per_page: size, page: current })
                                    })

                                    // this.list_fetcher_configs.config({
                                    //     params: {
                                    //         per_page: size,
                                    //         page: current
                                    //     }
                                    // }).execute();
                                },
                                defaultCurrent: 1,
                                current: rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0]),
                                // defaultPageSize: 20,
                                pageSize: (rowsMeta && rowsMeta.requested_count),

                                total: (rowsMeta && rowsMeta.total_count),
                                showTotal: (total, range) => `${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${formatMoney(total,0)} items`
                            }}
                            // bordered={false}
                            rowKey={(record) => record.id}
                            columns={fetcher_config_list({
                                onEditPressed: (data) => {
                                    this.setState({
                                        edit_config_id: data.id,
                                        add_edit_status: 'edit'
                                    })
                                },
                                onStatusChange:(id,data)=>{
                                    this.patch_fetcher_config.forId(id).execute(data)
                                }
                            })}
                            dataSource={rowsData}
                        />
                    </div>
                </ErrorWrapper>


                {/* For Fetcher Config Add */}
                <Drawer
                    title="Repository Add"
                    placement="right"
                    closable={false}
                    width='50%'
                    destroyOnClose
                    onClose={() => {
                        this.setState({
                            add_edit_status: null
                        });
                        this.list_fetcher_configs.execute();
                    }}
                    visible={this.state.add_edit_status === 'add'}
                >
                    <RepositoryConfigAddEdit
                        onClose={() => {
                            this.setState({
                                add_edit_status: null
                            });
                            this.list_fetcher_configs.execute()
                        }}
                        onRefreshClose={() => {
                            this.list_fetcher_configs.execute();
                            this.setState({
                                add_edit_status: null
                            })
                        }}

                    />
                </Drawer>
                <Drawer
                    title="Repository Edit"
                    placement="right"
                    closable={false}
                    width='50%'
                    destroyOnClose
                    onClose={() => {
                        this.setState({
                            add_edit_status: null
                        });
                        this.list_fetcher_configs.execute()
                    }}
                    visible={this.state.add_edit_status === 'edit'}
                >
                    <RepositoryConfigEdit
                        config_id={this.state.edit_config_id}
                        onClose={() => {
                            this.setState({
                                add_edit_status: null
                            })
                            this.list_fetcher_configs.execute()
                        }}
                        onRefreshClose={() => {
                            this.list_fetcher_configs.execute();
                            this.setState({
                                add_edit_status: null
                            })
                        }}
                    />
                </Drawer>
            </div>
        )
    }

    componentDidMount() {
        overrideHeaderTitle("Data Repository");
        overrideHeaderBack(null);
        let new_filter_query = {};
        if (this.props.location && this.props.location.search) {
            const parsed = queryString.parse(this.props.location.search);
            new_filter_query = parsed;
        }
        this.setState({
            filter_query: {
                per_page: 100,
                page: 1,
                ...new_filter_query
            }
        }, () => {
            this.list_fetcher_configs.config({
                params: {
                    ...this.state.filter_query
                }
            }).execute()
        })
    }

    componentWillReceiveProps(nextProps) {

        let new_filter_query = {};
        if ((this.props.location.search !== nextProps.location.search)) {
            const parsed = queryString.parse(nextProps.location.search);
            new_filter_query = parsed;
            this.setState({
                filter_query: {
                    per_page: 100,
                    page: 1,
                    ...new_filter_query
                }
            }, () => {
                this.list_fetcher_configs.config({
                    params: {
                        ...this.state.filter_query
                    }
                }).execute()
            })
        } else {
            //   this.list_logs.execute()
        }


    }

}

export default withDomains(RepositoryList, "datarepository", "settings");

